<template>
	<div class="text-center">
		<v-dialog
			v-model="show"
			width="555"
			@input="(v) => v || closeModal()"
			content-class="edit-note-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="edit-note-modal__card">
				<div class="d-flex mb-5 align-center flex-wrap">
					<div class="edit-note-modal__title text-2-lines">
						{{ edit ? 'Edit' : 'Add' }} Note about {{ username }}
					</div>
				</div>

				<NoteTextForm
					v-on:closeModal="closeModal"
					:id="id"
					:note="note"
					:edit="edit"
					:userPage="userPage"
				/>
				<button
					type="button"
					class="edit-note-modal__button-close"
					style="background-color: #ffffff !important"
					@click="closeModal"
				>
					<v-icon color="var(--button-icon-tint)">mdi-close</v-icon>
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NoteTextForm from '@/components/Forms/NoteTextForm.vue'
export default {
	components: { NoteTextForm },

	props: ['show', 'id', 'note', 'edit', 'username', 'userPage'],

	data: () => ({
		tab: null,
	}),

	methods: {
		...mapActions('chats', ['deleteMessage']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),

		closeModal() {
			this.$emit('closeModal')
		},
	},

	computed: {
		...mapGetters('settings', ['chaptersList']),
		...mapGetters('post', ['isFileLoading', 'postFile']),
		...mapGetters('tag', ['tags']),
	},

	created() {
		//
	},
}
</script>

<style lang="scss">
.edit-note-modal {
	border-radius: 8px;

	&__card {
		padding: 24px;
	}
	&__title {
		color: #4a4a4a;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
	}
	&__time {
		color: rgb(74, 74, 74);
		font-size: 12px;
		font-family: 'Inter', sans-serif;
		font-weight: 600;
		letter-spacing: -0.29px;
		padding: 10px 0;
	}
	&__tabs-wrapper {
		padding-bottom: 10px;

		.v-slide-group__wrapper {
			border-bottom: 1px solid rgb(219, 219, 219);
		}
	}
	&__button-close {
		position: absolute;
		top: 8px;
		right: 8px;
		background-color: #fff !important;
	}
}
</style>
